import { render } from "./as-lab-test-result-dropdown.vue?vue&type=template&id=61303b00&scoped=true&ts=true"
import script from "./as-lab-test-result-dropdown.vue?vue&type=script&lang=ts"
export * from "./as-lab-test-result-dropdown.vue?vue&type=script&lang=ts"

import "./as-lab-test-result-dropdown.vue?vue&type=style&index=0&id=61303b00&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\src\\WebUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61303b00"]])

export default __exports__